export const defaultSgaCompleto = () => {
    return {
        clasePeligro:'',
        palabraSga:'',
        indicaciones:'',
        prevencion:'',
        intervencion:'',
        almacenamiento:'',
        eliminacion:'',
    }
}
export default {
    selectedSgaCompletoEt: defaultSgaCompleto(),
    idioma:'Espanol',
    version: 6,
    clasificacionSGAListas: {
        sinSGA: ''
    }
}